// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageSelector_wrapper__4zkLQ","option":"LanguageSelector_option__AExaZ","active":"LanguageSelector_active__pw2vl"};